{
  "title": "Clients",
  "search": "Recherche",
  "completedUsersOnly": "Utilisateurs finalisés uniquement",
  "addModal": {
    "title": "Créer un nouveau client",
    "firstName": "Prénom",
    "middleName": "Deuxième prénom",
    "lastName": "Nom de famille",
    "email": "Courriel",
    "organization": "Organisation",
    "type": "Type de relation",
    "createAndLinkAuthProfile": "Créer et lier automatiquement un profil d'authentification",
    "autoInviteUser": "Inviter automatiquement l'utilisateur",
    "emailError": "Cette adresse e-mail existe déjà"
  },
  "table": {
    "id": "Pièce d'identité",
    "name": "Nom",
    "email": "Courriel",
    "suitabilityScore": "Score d'adéquation",
    "completedAt": "Terminé à",
    "organization": "Organisation",
    "province": "Province",
    "dateOfBirth": "Date de naissance",
    "notCompleted": "Non finalisé",
    "totalAssets": "Total des actifs"
  },
  "auditTypes": {
    "UPDATE": "Mettre à jour",
    "CREATE": "Créer",
    "DELETE": "Supprimer"
  }
}
